import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../common/store/api/BaseQueryConfig';
import { getLoggedInUserDetails } from '../../../utils/utils';
import { CommentsResponse, CommentsScenario } from '../../models/CommentsModel';
// Define a service using a base URL and expected endpoints
export const getCommentsApi = createApi({
    reducerPath: 'comments',
    baseQuery: axiosBaseQuery,
    endpoints: builder => ({
        GetComments: builder.query<CommentsResponse, string>({
            query: key => {
                return {
                    url: `/CommentNotifications/${
                        getLoggedInUserDetails().userId
                    }/feed`,
                    method: 'GET',
                };
            },
        }),
        GetSelectiveFeeds: builder.query<CommentsResponse, CommentsScenario>({
            query: key => {
                const params: Record<string, any> = {};
                if (key.scenario === 'unreadcomments') {
                    params.filter = JSON.stringify({ isUnread: true });
                }
                return {
                    url: `/CommentNotifications/${
                        getLoggedInUserDetails().userId
                    }`,
                    method: 'GET',
                    params,
                };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetCommentsQuery,
    useLazyGetCommentsQuery,
    useLazyGetSelectiveFeedsQuery,
    useGetSelectiveFeedsQuery,
} = getCommentsApi;
